import FieldConfig from "../../../../proto/field-config"
import FieldDate from "../../../../generic/datetime/date/date"
import Task from "../../../../../model2/task/task"
import ItemModelV2 from "../../../../../model2/item2/item-model"
import TasksViewManager from "../../../../../gd-modules/tasks-view/core/manager"
import FieldProto_updateView from "../../../../proto/render/table/function/update-view"
import FieldTaskDeadline_Editable from "./render/editable/editable"


export default class FieldTaskDeadline extends FieldDate {

    constructor(config:FieldConfig) {
        super(config);

        this.icon               = 'i5-deadline'
        this.label              = 'Deadline'

        this.minDate            = moment()

        this.renderComponents.editable          = FieldTaskDeadline_Editable

        this.fieldParams.tableCellOnValueChange = this.tableCellOnValueChange
    }

    // ACCESS
    canEdit(model:Task):boolean {
        return model.acl.canChangeDeadline
    }

    // Custom Methods

    tableCellOnValueChange = async (item: ItemModelV2, value:Moment|null, manager:TasksViewManager) => {

        item.task.deadline = value ? value : null
        item.task.save()

        item.updateLastUpdateTime() // otherwise it wont re-render

        // Aggregated values...
        FieldProto_updateView(manager as TasksViewManager, this)

    }
}
